import { HiArrowNarrowLeft } from 'react-icons/hi';
import './buttonBack.scss';
import { useNavigate } from 'react-router-dom';
import { routePaths } from '../../utils/constants';
import { useTranslation } from 'react-i18next';

const ButtonBack = (props: any) => {
  const { buttonName, handleBack } = props;
  const navigate = useNavigate();
  const [t] = useTranslation();

  const handleOnClick = () => {
    if (handleBack) {
      return handleBack()
    } return navigate(-1)
  }
  return (
    <div className="back-to-previous-page flex items-center ">
      <div
        className="arrow-left-icon mr-4 cursor-pointer"
        onClick={() => handleOnClick()}
      >
        <HiArrowNarrowLeft className="w-7 h-5" />
      </div>
      <p>{buttonName}</p>
    </div>
  );
};
export default ButtonBack;
